import styled from 'styled-components';

export const IntroductionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  p {
    margin: 0;
    text-align: left;
    font-size: 12px;
  }

  img {
    object-fit: cover;
  }
`;
